exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".survey-error-container[data-v-7eb65961]{min-height:100vh;display:flex;align-items:center;justify-content:center;padding:1rem;background-color:hsla(0,0%,96%,.5)}.card[data-v-7eb65961]{box-shadow:0 2px 8px rgba(0,0,0,.1)}.card-header-title[data-v-7eb65961]{padding:2rem 1.5rem 1.5rem}.icon-wrapper[data-v-7eb65961]{display:inline-flex;align-items:center;justify-content:center;width:4rem;height:4rem;border-radius:50%}.icon-wrapper.error[data-v-7eb65961]{background-color:rgba(241,70,104,.1)}.card-content[data-v-7eb65961]{padding:1rem 1.5rem 1.5rem}@media screen and (max-width:768px){.survey-error-container[data-v-7eb65961]{padding:1rem}.card-header-title[data-v-7eb65961]{padding:1.5rem 1rem 1rem}.card-content[data-v-7eb65961]{padding:1rem}.icon-wrapper[data-v-7eb65961]{width:3.5rem;height:3.5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eb65961","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/sections/survey/SurveyError.vue
// module id = 1968
// module chunks = 2